import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const KVKKPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-cream">
      <Header />
      <main>
        <section className="pt-32 pb-20">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-serif font-bold text-wood-dark mb-8">
                KVKK ve Gizlilik Politikası
              </h1>
              
              <div className="prose prose-lg max-w-none space-y-6 text-wood">
                <p className="text-sm text-wood/60">Son Güncelleme: 15 Ocak 2024</p>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">1. Veri Sorumlusu</h2>
                  <p>
                    6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu olarak İzmir Tadilat Firması tarafından aşağıda açıklanan kapsamda işlenebilecektir.
                  </p>
                  <p className="mt-4">
                    <strong>Adres:</strong> Poligon Mahallesi 1620 Sokak No:12 Karabağlar / İzmir<br />
                    <strong>Telefon:</strong> 0542 113 81 10<br />
                    <strong>E-posta:</strong> info@izmirtadilat.com
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">2. Kişisel Verilerin İşlenme Amacı</h2>
                  <p>Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Tadilat, dekorasyon ve iç mimarlık hizmetlerinin sunulması</li>
                    <li>Müşteri talep ve şikayetlerinin değerlendirilmesi</li>
                    <li>İletişim faaliyetlerinin yürütülmesi</li>
                    <li>Teklif hazırlanması ve sözleşme süreçlerinin yönetilmesi</li>
                    <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                    <li>Müşteri memnuniyeti anketlerinin yapılması</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">3. İşlenen Kişisel Veriler</h2>
                  <p>Aşağıdaki kişisel verileriniz işlenebilmektedir:</p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Kimlik Bilgileri: Ad, soyad, T.C. kimlik numarası</li>
                    <li>İletişim Bilgileri: Telefon numarası, e-posta adresi, adres</li>
                    <li>Müşteri İşlem Bilgileri: Hizmet talepleri, teklif bilgileri, sözleşme bilgileri</li>
                    <li>Finansal Bilgiler: Ödeme bilgileri, fatura bilgileri</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">4. Kişisel Verilerin Aktarılması</h2>
                  <p>
                    Toplanan kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda; iş ortaklarımıza, tedarikçilerimize, hukuki danışmanlarımıza ve yasal yükümlülüklerimiz çerçevesinde kamu kurum ve kuruluşlarına KVKK'nın 8. ve 9. maddelerinde belirtilen şartlara uygun olarak aktarılabilecektir.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">5. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</h2>
                  <p>
                    Kişisel verileriniz, web sitemiz, telefon, e-posta, sosyal medya kanalları ve yüz yüze görüşmeler aracılığıyla sözlü, yazılı veya elektronik ortamda toplanmaktadır. Toplanan kişisel verileriniz, KVKK'nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları kapsamında işlenmektedir.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">6. Kişisel Veri Sahibinin Hakları</h2>
                  <p>KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:</p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                    <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                    <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                    <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
                    <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                    <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
                    <li>Kişisel verilerinizin düzeltilmesi, silinmesi veya yok edilmesi halinde bu işlemlerin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
                    <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                    <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">7. İletişim</h2>
                  <p>
                    Yukarıda belirtilen haklarınızı kullanmak için kimliğinizi tespit edici gerekli bilgiler ile KVKK'nın 11. maddesinde belirtilen haklardan kullanmayı talep ettiğiniz hakkınıza yönelik açıklamalarınızı içeren talebinizi aşağıdaki iletişim kanallarından bize iletebilirsiniz:
                  </p>
                  <p className="mt-4">
                    <strong>E-posta:</strong> info@izmirtadilat.com<br />
                    <strong>Posta Adresi:</strong> Poligon Mahallesi 1620 Sokak No:12 Karabağlar / İzmir
                  </p>
                </section>

                <div className="mt-12 pt-8 border-t border-wood/20">
                  <Link
                    to="/"
                    className="inline-flex items-center text-wood hover:text-wood-dark font-medium transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-2"></i>
                    Anasayfaya Dön
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default KVKKPage;
